module.exports = __webpack_public_path__ + "static/media/espiga_galletera.ff13b32f.png";